import React, { PropsWithChildren } from 'react'

import clsx from 'clsx'

import './UserSettingsRow.scss'

export default function UserSettingsRow({
  className,
  children,
}: PropsWithChildren<{ className?: string | undefined }>) {
  return <div className={clsx('UserSettingsRow', className)}>{children}</div>
}
